import { t } from '@moovly/i18n';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import Page from '../../../components/Page';
import useOrganization from '../../../hooks/useOrganization';
import CreateGroupButtonContainer from '../containers/CreateGroupButtonContainer';
import GroupsListContainer from '../containers/GroupsListContainer';
import organizationSlice from '../store/organization.store';

const GroupsPage = () => {
  const organization = useOrganization();
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (organization) {
      dispatch(organizationSlice.actions.setGroups(organization.groups));
    }
  }, [organization, dispatch]);

  return (
    <Page header="workspaces" title={t('menu.organization.groups')} actions={<CreateGroupButtonContainer />}>
      <GroupsListContainer />
    </Page>
  );
};

export default GroupsPage;
